import { Divider, styled } from '@mui/material'

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginLeft: '24px',
  marginRight: '24px',
  borderColor: theme.palette.mainBodyColors.grayLight,
}))
